var _path, _path2, _path3, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYears({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22202",
    "data-name": "Group 22202",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24705",
    "data-name": "Path 24705",
    d: "M20.75,9.841,15.773,11.2a19.088,19.088,0,0,1-10.046,0L.75,9.841V8.023A3.637,3.637,0,0,1,4.386,4.386H17.114A3.637,3.637,0,0,1,20.75,8.023Z",
    fill: "rgba(0,0,0,0)",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24706",
    "data-name": "Path 24706",
    d: "M20.75,9.841v7.273a3.636,3.636,0,0,1-3.636,3.636H4.386A3.636,3.636,0,0,1,.75,17.114V9.841",
    fill: "rgba(0,0,0,0)",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24707",
    "data-name": "Path 24707",
    d: "M14.386,4.386H7.113V3.477A2.727,2.727,0,0,1,9.841.75h1.818a2.727,2.727,0,0,1,2.727,2.727Z",
    fill: "rgba(0,0,0,0)",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_161",
    "data-name": "Line 161",
    y2: 1.818,
    transform: "translate(10.75 12.568)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYears);
export default __webpack_public_path__ + "static/media/years.9ec309ff2e018cf990eeac4d8197eef6.svg";
export { ForwardRef as ReactComponent };